import { render, staticRenderFns } from "./KlaimHadiahSpektakuler.vue?vue&type=template&id=f0f3804e&scoped=true&"
import script from "./KlaimHadiahSpektakuler.vue?vue&type=script&lang=js&"
export * from "./KlaimHadiahSpektakuler.vue?vue&type=script&lang=js&"
import style0 from "./KlaimHadiahSpektakuler.vue?vue&type=style&index=0&id=f0f3804e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0f3804e",
  null
  
)

export default component.exports